<div class="card">
  <div class="card-body">
    <div>
      <p class="h4 m-0">Revise as Informações do Evento</p>
      <p class="p text-secondary">
        Confira todos os detalhes antes de concluir. Certifique-se de que tudo está correto para o sucesso do seu
        evento.
      </p>
    </div>

    <ul class="list-group list-group-flush">
      <!-- Nome -->
      <li
        class="list-group-item"
        [ngClass]="{ 'list-group-item-success': eventForm.controls.basicInfo.controls.title.value }">
        <div class="d-flex justify-content-start align-items-center gap-3">
          <div>
            <p class="h6 alert-heading d-flex align-items-center gap-2">
              Nome
              @if (eventForm.controls.basicInfo.controls.title.value) {
                <i class="pi pi-check"></i>
              }
            </p>

            <p class="p text-secondary">
              {{ eventForm.controls.basicInfo.controls.title.value || "Não informado" }}
            </p>
          </div>
        </div>
      </li>

      <!-- Categoria -->
      <li
        class="list-group-item"
        [ngClass]="{ 'list-group-item-success': eventForm.controls.basicInfo.controls.eventCategoryId.value }">
        <div class="d-flex justify-content-start align-items-center gap-3">
          <div>
            <p class="h6 alert-heading d-flex align-items-center gap-2">
              Categoria
              @if (eventForm.controls.basicInfo.controls.eventCategoryId.value) {
                <i class="pi pi-check"></i>
              }
            </p>

            <p class="p text-secondary">
              @if (eventForm.controls.basicInfo.controls.eventCategoryId.value) {
                {{ getEventCategoryName(eventForm.controls.basicInfo.controls.eventCategoryId.value!) }}
              } @else {
                Não informado
              }
            </p>
          </div>
        </div>
      </li>

      <!-- Descrição -->
      <li
        class="list-group-item"
        [ngClass]="{ 'list-group-item-success': eventForm.controls.basicInfo.controls.description.value }">
        <div class="d-flex justify-content-start align-items-center gap-3">
          <div>
            <p class="h6 alert-heading d-flex align-items-center gap-2">
              Descrição
              @if (eventForm.controls.basicInfo.controls.description.value) {
                <i class="pi pi-check"></i>
              }
            </p>

            <div [innerHTML]="eventForm.controls.basicInfo.controls.description.value || 'Não informado'"></div>
          </div>
        </div>
      </li>

      <!-- Endereço -->
      <li
        class="list-group-item"
        [ngClass]="{
          'list-group-item-success':
            eventForm.controls.address.controls.street.value && eventForm.controls.address.controls.number.value,
        }">
        <div class="d-flex justify-content-start align-items-center gap-3">
          <div>
            <p class="h6 alert-heading d-flex align-items-center gap-2">
              Endereço do evento
              @if (
                eventForm.controls.address.controls.street.value && eventForm.controls.address.controls.number.value
              ) {
                <i class="pi pi-check"></i>
              }
            </p>

            <p class="p text-secondary">
              @if (
                eventForm.controls.address.controls.street.value && eventForm.controls.address.controls.number.value
              ) {
                {{
                  (eventForm.controls.address.controls.location_name?.value || "") +
                    (eventForm.controls.address.controls.location_name?.value ? " - " : "") +
                    (eventForm.controls.address.controls.street.value || "") +
                    (eventForm.controls.address.controls.number.value
                      ? ", " + eventForm.controls.address.controls.number.value
                      : "") +
                    (eventForm.controls.address.controls.district.value
                      ? " - " + eventForm.controls.address.controls.district.value
                      : "") +
                    (eventForm.controls.address.controls.city_name.value
                      ? " - " + eventForm.controls.address.controls.city_name.value
                      : "") +
                    (eventForm.controls.address.controls.state.value
                      ? " - " + eventForm.controls.address.controls.state.value
                      : "")
                }}
              } @else {
                Não informado
              }
            </p>
          </div>
        </div>
      </li>

      <!-- Data/Hora início -->
      <li
        class="list-group-item"
        [ngClass]="{ 'list-group-item-success': eventForm.controls.eventDates.controls.startDateTime.value }">
        <div class="d-flex justify-content-start align-items-center gap-3">
          <div>
            <p class="h6 alert-heading d-flex align-items-center gap-2">
              Data e hora de início do evento
              @if (eventForm.controls.eventDates.controls.startDateTime.value) {
                <i class="pi pi-check"></i>
              }
            </p>

            <p class="p text-secondary">
              @if (eventForm.controls.eventDates.controls.startDateTime.value) {
                {{ eventForm.controls.eventDates.controls.startDateTime.value | date: "dd/MM/yyyy HH:mm" }}
              } @else {
                Não informado
              }
            </p>
          </div>
        </div>
      </li>

      <!-- Data/Hora término -->
      <li
        class="list-group-item"
        [ngClass]="{ 'list-group-item-success': eventForm.controls.eventDates.controls.endDateTime.value }">
        <div class="d-flex justify-content-start align-items-center gap-3">
          <div>
            <p class="h6 alert-heading d-flex align-items-center gap-2">
              Data e hora de término do evento
              @if (eventForm.controls.eventDates.controls.endDateTime.value) {
                <i class="pi pi-check"></i>
              }
            </p>

            <p class="p text-secondary">
              @if (eventForm.controls.eventDates.controls.endDateTime.value) {
                {{ eventForm.controls.eventDates.controls.endDateTime.value | date: "dd/MM/yyyy HH:mm" }}
              } @else {
                Não informado
              }
            </p>
          </div>
        </div>
      </li>

      <!-- Resumo dos ingressos -->
      <li
        class="list-group-item"
        [ngClass]="{ 'list-group-item-success': ticketBatches.length > 0 || isFreePrivateEvent }">
        <div>
          <p class="h6 alert-heading d-flex align-items-center gap-2">
            Resumo dos ingressos
            @if (ticketBatches.length > 0 || isFreePrivateEvent) {
              <i class="pi pi-check"></i>
            }
          </p>

          @if (isFreePrivateEvent) {
            <p class="p text-secondary m-0">
              Os ingressos serão gerados pela lista de convidados após a criação do evento.
            </p>
          } @else if (ticketBatches.length > 0) {
            <div class="d-flex flex-column gap-3">
              @for (ticketBatch of ticketBatches; track ticketBatch; let batchIndex = $index) {
                <app-batch-summary [batch]="ticketBatch" [batchIndex]="batchIndex"
                  [management]="!!eventId" [transitionDisabledReason]="transitionDisabledReason"
                  (batchesChanged)="batchesTransitioned.emit($event)"></app-batch-summary>
              }
            </div>
          } @else {
            <p class="p text-secondary">Sem ingressos criados</p>
          }
        </div>
      </li>
      <!-- Resumo dos ingressos combo -->
      <li class="list-group-item" [ngClass]="{ 'list-group-item-success': combos.length > 0 }">
        <div>
          <p class="h6 alert-heading d-flex align-items-center gap-2">
            Resumo dos ingressos combo
            @if (combos.length > 0) {
              <i class="pi pi-check"></i>
            }
          </p>

          @if (combos.length > 0) {
            <div class="d-flex flex-column gap-2">
              @for (combo of combos; track combo) {
                <div class="border rounded p-2">
                  <strong>{{ combo.title }}</strong>
                  @if (combo.source_batch_number) {
                    <span class="text-secondary ms-2">Lote {{ combo.source_batch_number }}</span>
                  }
                  <span class="text-secondary ms-2">
                    @for (ticket of combo.component_tickets; track ticket; let last = $last) {
                      {{ ticket.title }}@if (!last) { + }
                    }
                    | Cota: {{ combo.quantity }} | Preço: {{ combo.price | currency: "BRL" }}
                  </span>
                </div>
              }
            </div>
          } @else {
            <p class="p text-secondary">Nenhum ingresso combo criado</p>
          }
        </div>
      </li>
      <!-- Resumo dos espaços -->
      <li class="list-group-item" [ngClass]="{ 'list-group-item-success': spaces.length > 0 }">
        <div>
          <p class="h6 alert-heading d-flex align-items-center gap-2">
            Resumo dos espaços
            @if (spaces.length > 0) {
              <i class="pi pi-check"></i>
            }
          </p>

          @if (spaces.length > 0) {
            <div class="d-flex flex-column gap-2">
              @for (space of spaces; track space; let i = $index) {
                <div class="border rounded p-2">
                  <strong>{{ space.title }}</strong>
                  <span class="text-secondary ms-2">
                    Qtd: {{ space.quantity }} | Preço: {{ space.price | currency: "BRL" }} | Consumação:
                    {{ space.consumption | currency: "BRL" }}
                  </span>
                </div>
              }
            </div>
          } @else {
            <p class="p text-secondary">Nenhum espaço criado</p>
          }
        </div>
      </li>
    </ul>
    <form [formGroup]="eventForm.controls.eventSummary">
      <div class="col-12 mb-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" formControlName="acceptedTerms" id="accepted_terms" />
          <label class="form-check-label" for="accepted_terms">
            Eu li e aceito os <a href="/terms-of-use" target="_blank">termos e condições</a> do site.
          </label>
        </div>

        @if (
          eventForm.controls.eventSummary.controls.acceptedTerms.invalid &&
          eventForm.controls.eventSummary.controls.acceptedTerms.touched
        ) {
          <small class="text-danger">Você precisa aceitar os termos e condições para continuar.</small>
        }

        @if (eventId) {
          <div class="alert alert-warning d-flex align-items-center gap-3 rounded mt-3" role="alert">
            <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
            <p class="m-0">
              <strong>Atenção:</strong> Ao salvar estas alterações, todos os compradores serão automaticamente
              notificados e poderão solicitar reembolso, conforme nossos
              <a href="/terms-of-use" target="_blank" class="alert-link"
                >termos de uso<span class="sr-only">(abre em nova janela)</span></a
              >.
            </p>
          </div>
        }

        <div class="row d-flex gap-3 justify-content-between">
          <div class="col-sm-12 col-md-4 col-lg-3">
            <p class="form-label m-0">Visibilidade do evento</p>
            <p class="form-control-plaintext m-0 fw-bold">
              {{ isPrivateEvent ? "Privado" : "Público" }}
            </p>
            <small class="text-secondary"> Para alterar, volte à etapa "Tipo e visibilidade do evento". </small>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Finalização (usa o group do próprio eventForm) -->
